import React from "react";
import JsPDF from "jspdf";

class WebCnArticles extends React.Component {
  state = {
    sumNoVat: 0.0,
    showSave: false,
    showType: "",
    input: "",
    inputType: ""
  };

  GeneratePdf = () => {
    const report = new JsPDF("portrait", "pt", "a4");
    report.html(document.getElementById("pdf-content")).then(() => {
      report.save("report.pdf");
    });
  };

  

  summary = (e) => {
    var sum = 0.0;
    e.map((x) => {
      sum += x.ArticlePrice;
    });
    this.setState({ sumNoVat: sum });
  };

  componentDidMount() {
    this.setState({input: this.props.dataNtf.value, inputType: this.props.dataNtf.label})
    this.summary(this.props.dataCN);
  }

  render() {
    const { Bs, VARIANT, SIZE, curr, rate } = this.props;
    return (
      <>
      <Bs
          modal
          show={this.state.showSave}
          onHide={() =>
            this.setState({showSave: false})
          }
          keyboard={false}
          backdrop="static"
          centered
          size={SIZE.MD}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Bs modalheader closeButton>
            Nyní je vyžadováno potvrzení
          </Bs>
          <Bs modalbody>
            <Bs row>
              <Bs col>
                <Bs small>
                 {this.state.showType === "confirm" ? "Notifikace bude odslána na " + this.state.inputType : "Zakázka bude přehozena do předchozího stavu"} 
                </Bs>
              </Bs>
            </Bs>
            {this.state.showType === "confirm" && (
              <Bs row className="mt-2">
              <Bs col>
                <Bs
                  formcontrol
                  type="text"
                  value={this.state.input}
                  onChange={(e) => this.setState({ input: e.target.value })}
                />
              </Bs>
            </Bs>
            )}
            <Bs row className="mt-4">
              <Bs col className="d-flex justify-content-end">
                <Bs
                  button
                  variant={VARIANT.TRANSPARENT}
                  size={SIZE.SM}
                  className="me-4"
                  onClick={() => {
                    this.setState({showSave: false})
                  }}
                >
                  Zrušit
                </Bs>
                <Bs
                  button
                  variant={VARIANT.SUCCESS}
                  size={SIZE.SM}
                  onClick={() => {
                    this.props.sent(this.state.input,this.state.inputType,this.state.sumNoVat,this.state.showType)
                    this.setState({showSave: false})
                  }}
                >
                  Potvrdit
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
        <Bs row className="mt-4">
          <Bs col xs={12} className="d-flex justify-content-between">
            <Bs strong>Celkem bez DPH</Bs> <Bs span>{curr} {Math.round(this.state.sumNoVat*100)/100}</Bs>
            <Bs strong>Celkem se DPH</Bs> <Bs span>{curr} {Math.round((this.state.sumNoVat*rate)*100)/100}</Bs>
          </Bs>
        </Bs>
        <Bs row className="mt-4">
          <Bs col xs={12} className="d-flex justify-content-end">
            <Bs
              button
              variant={VARIANT.SECONDARY}
              size={SIZE.SM}
              className="me-4"
              onClick={() => this.setState({showSave: true,showType: "return"})}
            >
              Vrátit
            </Bs>
            <Bs
              button
              variant={VARIANT.SUCCESS}
              size={SIZE.SM}
              onClick={() => this.setState({showSave: true,showType: "confirm"})}
            >
              Odeslat
            </Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}

export default WebCnArticles;
